import * as actionTypes from 'constants/ActionTypes';

const realCompanies = (state = {
    items: [],
    isLoaded: false,
}, action) => {
    switch (action.type) {
        case actionTypes.GET_REAL_COMPANIES.REQUEST:
            return {
                ...state,
            };
        case actionTypes.GET_REAL_COMPANIES.SUCCESS: {
            return {
                ...state,
                items: action.data,
                isLoaded: true,
            };
        }
        case actionTypes.GET_REAL_COMPANIES.FAILURE:
            return {
                ...state,
                isLoaded: true,
            };

        default:
            return state;
    }
};

export default realCompanies;



// WEBPACK FOOTER //
// ./app/reducers/realCompanies.js